import script from "./Toast.vue?vue&type=script&setup=true&lang=js"
export * from "./Toast.vue?vue&type=script&setup=true&lang=js"

import "./Toast.vue?vue&type=style&index=0&id=47d430de&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d430de"]])

export default __exports__